/**
 * Локализация сообщений GoTrue на форме входа (UC1101, WP-DSP-3-FIX / D-G3-1).
 * Технические коды в UI не показываются; неизвестный текст — общая фраза с исходным сообщением.
 */
const KNOWN = [
    [/invalid login credentials/i, "Неверный email или пароль"],
    [/user is banned|banned/i, "Учётная запись заблокирована. Обратитесь к оператору сервиса"],
    [/email not confirmed/i, "Email не подтверждён — обратитесь к оператору сервиса"],
    [/too many requests|rate limit|over_request_rate_limit/i, "Слишком много попыток — попробуйте через несколько минут"],
    [/session.*(expired|missing)|refresh token/i, "Сессия завершена — войдите снова"],
    [/network|fetch failed|failed to fetch/i, "Нет связи с сервером — проверьте подключение"],
];
export const localizeAuthError = (message, fallback = "Не удалось войти") => {
    const text = (message ?? "").trim();
    if (!text)
        return fallback;
    const hit = KNOWN.find(([re]) => re.test(text));
    return hit ? hit[1] : `${fallback}: ${text}`;
};
